import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../item-info-popover/item-info-popover.component';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'table-services-used',
	templateUrl: './table-services-used.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule, ItemInfoPopoverComponent ]
})
export class TableServicesUsedComponent implements OnInit {
	
	@Input() generatedPreview: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.getReportSessionDescriptor = this.getReportSessionDescriptor;
	}
	
	getReportSessionDescriptor(type) {
		if (!!this.vm.generatedPreview && !!this.vm.generatedPreview.sessionsDescriptors) {
			return this.vm.generatedPreview.sessionsDescriptors.filter((descriptor) => {
				return descriptor.type === type;
			})[0];
		}
		return {};
	}
	
}
